import { IResult, UAParser } from "ua-parser-js";

export class UAParserUtils {
  static isMobile(result: IResult) {
    const ua = navigator.userAgent || "";
    const parser = new UAParser(ua);
    const osName = (parser.getOS().name || "").toLowerCase();
    const deviceType = parser.getDevice().type; // 'mobile' | 'tablet' | ... | undefined
    const isIOS = osName.includes("ios");
    const isAndroid = osName.includes("android");
    const isMobileLike = deviceType === "mobile" || deviceType === "tablet";
    // WebView heuristic remains as ua-parser-js does not expose a direct flag
    const isWebView =
      /; wv\)/i.test(ua) || (isAndroid && !/Chrome\/\d/.test(ua));

    // Prefer robust, explicit OS/device checks. This ensures iOS WKWebView is treated as mobile.
    return (
      result.device.type === "mobile" || isIOS || isAndroid || isMobileLike
    );
  }

  static isWkWebView(result: IResult) {
    return result.browser.name === "WebKit";
  }

  static isChromeWebView(result: IResult) {
    return result.browser.name === "Chrome WebView";
  }

  static isMobileWebView(result: IResult) {
    return (
      UAParserUtils.isChromeWebView(result) || UAParserUtils.isWkWebView(result)
    );
  }
}
